// Components==============
import React, { useContext } from 'react';
import { useTranslate } from 'hooks/useTranslate';
import Button from 'components/UI/Button/Button';
import { AssessmentContext } from '../../Feedback';
// =========================

export default function ToggleAllButton() {
  const translate = useTranslate();
  const { toggled, onClickToggle } = useContext(AssessmentContext);

  return (
    <>
      <Button onClick={onClickToggle} color={toggled ? 'blue' : 'white'}>
        {toggled
          ? translate('project.actions.close-all')
          : translate('project.actions.open-all')}
      </Button>
    </>
  );
}
